import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { ArchivalUnitCopy } from 'types';
import LoaderOverlay from 'components/loader/loader-overlay';
import { CacheKeys } from 'cache-keys-enum';
import {
  findValidDescribingAidId,
  GridRootUrl,
} from 'components/grid/v2/context/hierarchy-context';

const useArchivalUnitDetail = (id: string) =>
  useQuery([CacheKeys.ARCHIVAL_UNIT, id], () =>
    fetch(`/badatelna/api/archival-unit/public/view/${id}`).then(
      async (r) => (r.json() as unknown) as ArchivalUnitCopy
    )
  );

const ArchivalUnitSwitch = () => {
  const { id } = useParams<{ id: string }>();
  const resp = useArchivalUnitDetail(id);
  const { replace } = useHistory();

  if (resp.isLoading) {
    return <LoaderOverlay />;
  }

  if (resp.isSuccess) {
    const eadId = resp.data?.eadNode?.id ?? '';
    const rootArchivalAidId = findValidDescribingAidId(
      resp.data?.archivalUnitReference?.describingArchivalAids
    );
    if (eadId && rootArchivalAidId) {
      replace(`${GridRootUrl.AIDS}/${rootArchivalAidId}/ead/${eadId}`);
    } else {
      const collectionId =
        resp.data?.archivalUnitReference?.archivalCollection?.id;
      if (collectionId) {
        replace(`${GridRootUrl.COLLECTIONS}/${collectionId}/archivalie/${id}`);
      } else {
        replace(`/archivalie/0/${id}`);
      }
    }
  }
  if (resp.isError) {
    replace(`/archivalie/0/${id}`);
  }
  return <LoaderOverlay />;
};

export default ArchivalUnitSwitch;
